import { mainPath } from "../../lib/mainPath"
import { requestsTemplates } from "../../lib/requestsTemplates"

export const put = (id, departmentObj) => requestsTemplates.put(mainPath, `/departments/${id}`, departmentObj)
